import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';
import AccountModel        from '@models/account/AccountModel';

@model.urnResource('account_billing_profile')
@doc.path('/account_billing_profiles/{?id}')
export default class AccountBillingProfileModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'account': id;
		'id': id;
	};

	private declare _tsSorts: {
		'billingName': string;
		'id': string;
	};

	@doc.string declare billingAddress: string;
	@doc.string declare billingAddressAdditional: string;
	@doc.string declare billingAddressCity: string;
	@doc.string declare billingAddressCountry: string;
	@doc.string declare billingAddressZipCode: string;
	@doc.string declare billingName: string;
	@doc.string declare vatNumber: string;
	@doc.model(AccountModel) declare account: AccountModel;
}
